// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { creditCardDetailsEntryStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import InfoAlert from "@guestsupply/XDL/Icons/InfoAlert";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

creditCardDetailsEntryStyles.securityCodeHintLink = {
    ...createLinkIconStyles(InfoAlert, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                margin-left: 2px;
                line-height: 12px;
            `,
        },
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
            },
            position: "right",
        },
        css: css`
            &&& {
                display: flex;
            }
        `,
    }),
};
creditCardDetailsEntryStyles.creditCardDetailsHeading = {
    variant: "h5",
} as TypographyProps;
